import React, {Component} from 'react';
import {
    Switch,
    Route,
    Redirect
  } from "react-router-dom";
import Footer from './estructura/Footer';
import Top from './estructura/Top';
import Municipi from './Municipi';
import Api from '../Api';
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import Container from 'react-bootstrap/Container';
import Comarca from './Comarca';
import Catalunya from './Catalunya';
import Mapes from './Mapes';
import Participacio from './Participacio';


class Main extends Component {

state = {
  pantalla: 1,
  municipis: [],
  partits: [],
  resultats: [],
  resultatsTotals: []
}

// Dades globals

obteDadesGlobals() {  
  
  //Partits polítics
  var baseURL = `partit/llistaRegistres.php`;
  var partits;
  Api.get(baseURL)
  .then(res => {
      if (res.status===200){
          partits = res.data;
          this.setState({partits});
      } else this.setState({pantalla:3, missatge:res.data.missatge})
    }) 
  .catch (error => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.setState({pantalla:3, missatge:error.response.data.missatge});
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
        }
        console.log(error.config);
    }) //si surt ERROR 40X

  //Municipis
  baseURL = `municipi/index.php`;
  var municipis;
  Api.get(baseURL)
  .then(res => {
      if (res.status===200){
          municipis = res.data;
          this.setState({municipis});
          
      } else this.setState({pantalla:3, missatge:res.data.missatge})
    }) 
  .catch (error => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.setState({pantalla:3, missatge:error.response.data.missatge});
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
        }
        console.log(error.config);
    }) //si surt ERROR 40X

  }

  //DADES ACTUALITZABLES

  obteDades() {
 
    //Resultats
  var baseURL = `resultats/resultatsBergueda.php`;
  var resultats;
  Api.get(baseURL)
  .then(res => {
      if (res.status===200){
          resultats = res.data;
          this.setState({resultats});
          
      } else this.setState({pantalla:3, missatge:res.data.missatge})
    }) 
  .catch (error => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.setState({pantalla:3, missatge:error.response.data.missatge});
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
        }
        console.log(error.config);
    }) //si surt ERROR 40X

     //Resultats totals per comarca i Catalunya
  baseURL = `resultats/resultatsTotal.php`;
  var resultatsTotals;
  Api.get(baseURL)
  .then(res => {
      if (res.status===200){
          resultatsTotals = res.data;
          this.setState({resultatsTotals});
          
      } else this.setState({pantalla:3, missatge:res.data.missatge})
    }) 
  .catch (error => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.setState({pantalla:3, missatge:error.response.data.missatge});
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          this.setState({pantalla:3, missatge:"Error en connexió a l'API"});
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          this.setState({pantalla:3, missatge:"No hi ha connexió a Internet"});
        }
        console.log(error.config);
    }) //si surt ERROR 40X
  


} 




componentDidMount() {
  this.obteDadesGlobals();
  this.obteDades();

  this.interval = setInterval(function() {
    this.obteDades();
  }.bind(this), 120000)
}

  
render() {
  
  if (this.state.municipis.length>0&&this.state.partits.length>0&&this.state.resultats.length>0&&this.state.resultatsTotals.length>0&&this.state.pantalla!==2) {
      this.setState({pantalla:2})
  }

  return (
    <div className="App">
        <header className="App-header">
            <Top/>
        </header>

        {this.state.pantalla===1 &&
          <Container>
            <div className="carregant">
              <Spinner animation="grow" role="status" variant="primary"> 
                    <span className="sr-only">Carregant</span>
              </Spinner>
            </div>
          </Container>
        }
        
        {this.state.pantalla===2 &&
        <div className="App-body">
            {/* Route ens enllaça a cada component */}
                
                    <Switch>
                        <Route path ="/bergueda/:opcions?" render={(params) => (<Comarca {...params} municipis={this.state.municipis} resultats={this.state.resultatsTotals} partits={this.state.partits} resultatsMunicipis={this.state.resultats}/>)}/>
                        <Route path ="/catalunya/:opcions?" render={(params) => (<Catalunya {...params} resultats={this.state.resultatsTotals} partits={this.state.partits}/>)}/>
                        <Route path ="/resultats" render={(params) => (<Municipi {...params} municipis={this.state.municipis} resultats={this.state.resultats} partits={this.state.partits}/>)}/>
                        <Route path ="/mapes" render={(params) => (<Mapes {...params} municipis={this.state.municipis} resultats={this.state.resultats} partits={this.state.partits}/>)}/>
                        <Route path ="/participacio" render={(params) => (<Participacio {...params} municipis={this.state.municipis} resultats={this.state.resultats} resultatsTotals={this.state.resultatsTotals}/>)}/>
                        <Route path ="/" render={() => (<Redirect to="/resultats" />)}/>
                        
                    </Switch>

        </div>
        }

        {this.state.pantalla===3 &&
        <div className="error">
            {/* Route ens enllaça a cada component */}
            <Container>   
            <Alert variant='danger'>
            Error: {this.state.missatge}
          </Alert></Container> 

        </div>
        }



        <footer className="App-footer">
            <Footer/>
        </footer>
  </div>
  );
}

}

export default Main; 